import { Grid, Divider, Stack, Group, ActionIcon, Badge, Text } from "@mantine/core";
import { IconExternalLink, IconCircleCheck, IconExclamationCircle } from "@tabler/icons-react";

import { ReservationLinkStatus, ReservationLinkType } from "../../models/programregistration.models";
import { useProgramRegistrationState } from "../../state/programregistration.state";
import ReservationLinkEditor from "./ReservationLinkEditor";
import { useProgramGroupsQuery } from "../../api/program.api";

const ReservationLinkView = () => {
	const { programRegistration } = useProgramRegistrationState();
	const { data: programGroups, isLoading: isLoadingProgramGroups } = useProgramGroupsQuery();
	const programGroup = programGroups?.find(p => p.Id === (programRegistration?.Data.ProgramGroupId ?? 0));

	const getReservationLink = () => {
		var reservationNumber = programRegistration?.Data.ReservationLink?.ReservationNumber ?? "";
		if (import.meta.env.VITE_ORG === "MBC")
			return `http://hero.mbc.local/#/search/reservation/${reservationNumber}`;
		else 
			return `http://icamp.fairhavens.local/#/search/reservation/${reservationNumber}`;
	}

	// if (!programRegistration?.Data.ReservationLink) {
	if (!programGroup || !programGroup.RequireReservationNumber) {
		return <></>;
	}

	let reservationNumberOrAddress = programRegistration?.Data?.ReservationLink?.Type === ReservationLinkType.ReservationNumber
		? programRegistration?.Data?.ReservationLink?.ReservationNumber
		: programRegistration?.Data?.ReservationLink?.StayAddress;

	if (reservationNumberOrAddress === undefined || reservationNumberOrAddress === "")
		reservationNumberOrAddress = "Not provided";

	return <>
		{programRegistration?.Data?.ReservationLink && <>
			<Grid.Col span={12}>
			<Divider />
			</Grid.Col>
			<Grid.Col span={{ base: 4, md: 3 }} py={0}>
				<Text ta="right" c="dimmed" size="sm">
					{programRegistration.Data?.ReservationLink?.Type === ReservationLinkType.ReservationNumber && import.meta.env.VITE_ORG === "MBC" && "HERO Reservation #:"}
					{programRegistration.Data?.ReservationLink?.Type === ReservationLinkType.ReservationNumber && import.meta.env.VITE_ORG !== "MBC" && "iCamp Reservation #:"}
					{programRegistration.Data?.ReservationLink?.Type === ReservationLinkType.PrivateRental && "Stay Address:"}
					{programRegistration.Data?.ReservationLink?.Type === ReservationLinkType.None && "Stay Location:"}
				</Text>
			</Grid.Col>
			<Grid.Col span={{ base: 8, md: 6 }} py={0}>
				<Stack gap={0} mt={-3}>
					<Group gap={5} wrap="nowrap">
						<Text>{reservationNumberOrAddress}</Text>
						{programRegistration.Data?.ReservationLink?.Type === ReservationLinkType.ReservationNumber && (
							<ActionIcon variant="subtle" size="md" mt={-4} component="a" href={getReservationLink()} target="_blank" rel="noopener noreferrer">
								<IconExternalLink size={20} />
							</ActionIcon>
						)}
					</Group>
					<Group gap={3}>
						{programRegistration?.Data?.ReservationLink?.Verified ? (
							<Badge size="sm" color="green" variant="filled" leftSection={<IconCircleCheck size={14} strokeWidth={2} style={{ marginLeft: '-6px' }} />} pr={4}>
								Verified
							</Badge>
						) : (
							<Badge size="sm" color="orange" leftSection={<IconExclamationCircle size={14} strokeWidth={2} style={{ marginLeft: '-6px'}} />} pr={4}>
								Unverified
							</Badge>
						)}
						{programRegistration?.Data?.ReservationLink?.Status === ReservationLinkStatus.AutomaticallyLinked ? (
							<Badge size="sm" color="green" variant="dot">Automatic</Badge>
						) : programRegistration?.Data?.ReservationLink?.Status === ReservationLinkStatus.ManuallyLinked ? (
							<Badge size="sm" color="orange" variant="dot">Manual</Badge>
						) : null}
					</Group>
				</Stack>
			</Grid.Col>

			<Grid.Col span={{ base: 12, md: 3 }} pt={5}>
				<Group gap={5} justify="end" wrap="nowrap">
					<ReservationLinkEditor />
				</Group>
			</Grid.Col>
		</>}
	</>
}

export default ReservationLinkView;